export default __webpack_public_path__ + "static/media/countdown.d9749bae.jpg";